import { StyleSheet, Platform } from 'react-native'

const styles = StyleSheet.create({
  header: (theme) => ({
    backgroundColor: theme.colors.backgroundColorFive,
    marginBottom: 20
  }),
  itemsContainer: {
    flex: 1,
  },
  itemsContentContainer: {
    flexGrow: 1,
    paddingBottom: 200,
  },
  sectionTitle: {
    padding: 16,
  },
  filters: (theme) => ({
    padding: 16,
    paddingBottom: 6,
    color: theme.colors.textColorThree,
  }),
  recomendedContentContainer: {
    padding: 10,
    paddingTop: 2,
  },
  filtersContentContainer: {
    padding: 10,
    paddingBottom: 0,
  },
  divider: (theme) => ({
    height: 1,
    backgroundColor: theme.colors.divider,
    marginTop: 12,
    marginHorizontal: 14,
  }),
})

export default styles
